import { Params } from '@angular/router';
import { EIcon } from '../../icons/models/icons.enum';

export class MenuItem {

  constructor(
    public linkText: string,
    public path: string,
    public pathOpts: string,
    public external: boolean,
    public hasPermission: boolean,
    public queryParams?: Params | null | undefined,
    public submenu?: MenuItem[],
    public icon?: EIcon
  ) {}
}